import React, {ReactNode} from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export interface Props<T = string> {
  onChange: (value: T) => void
  value?: T
  fieldType?: string
  placeholder?: string
  errorMessage?: ReactNode | string
  label?: ReactNode | string
  description?: ReactNode | string
  fieldName?: string
  options?: {value?: string; label?: string}[]
  isClearable?: boolean
}

export default function SimpleSelect(props: Props) {
  const isDarkMode = useIsDarkMode()
  return (
    <div className="mb-2">
      {props.label ? (
        <label className="block text-sm font-medium text-gray-700">{props.label}</label>
      ) : null}
      <select
        className={classnames('mt-1 block w-full rounded-md py-2 pl-3 pr-10 text-base h-12', {
          'border border-gray-200 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ':
            !isDarkMode,
          'bg-gray-700 border-gray-300 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ':
            isDarkMode,
          'text-gray-300': !props.value
        })}
        value={props.value || ''}
        placeholder={props.placeholder}
        onChange={e => props.onChange(e.target.value || undefined)}>
        {props.isClearable ? <option value="">{props.placeholder}</option> : null}
        {props.options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
